import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Pipe,
  PipeTransform,
  ViewChild
} from '@angular/core'
import {VendorMinInf} from '../../../interfaces/common'
import {Level, LevelProduct, VendorProductForPicker} from '../level.picker.iface'
import {LevelPickerService} from '../level.picker.service'
import {NotificatorService} from '../../../services/notificator.service'
import {MlVsService} from '../../ml-vendor.search/ml.vs.service'
import {VendorSearch} from '../../../interfaces/vendor-details'
import {forkJoin, Subscription} from 'rxjs'
import {AuthService} from '../../../services/auth.service'

@Pipe({
    name: 'checkRatesForMakeColumns',
    pure: true,
    standalone: false
})
export class CheckRatesOnNullPipe implements PipeTransform {
  transform(data: LevelProduct[], isAdmin: boolean): string {
    let nullExists = false
    let notNull = false
    data.forEach(i => {
      if (i.markup === null && i.serviceFee === null) {
        nullExists = true
      }
      if (i.markup !== null || i.serviceFee !== null) {
        notNull = true
      }
    })
    return notNull && nullExists && isAdmin ? 'col-5' :
      notNull && !nullExists && isAdmin ? 'col-4' : 'col-3'
  }
}

@Component({
    selector: 'app-level-picker',
    templateUrl: 'level.picker.component.html',
    styleUrls: ['level.picker.component.css'],
    standalone: false
})

export class LevelPickerComponent implements OnInit, OnDestroy {
  @Input() define?: string // ID
  @Input() vendorId?: number | string
  @Input() category?: string
  @Input() showDetails?: boolean
  @Input() readOnly?: boolean // Using for display mode
  @Output() defineChange = new EventEmitter()
  @ViewChild('lvlPickerPopContent', { static: false }) pop: ElementRef


  currentLevelDetails: Level = {
    color: null,
    name: null,
    description: null,
    products: []
  }
  isUsrAdmin: boolean

  subVendorSelect: Subscription
  subCurrentUser: Subscription
  currentVendor: VendorMinInf
  vendorNotDefined: boolean

  preloader: boolean
  rateLevels: Level[] = []

  // popover
  visible: boolean

  popOpen(e: PointerEvent) {
    if (this.readOnly) {
      return
    }
    // console.log('open menu/modal/drawer', this.pop, e)
    this.visible = true
    this.pop.nativeElement.togglePopover()
  }

  popCheck(e: Event) {
    // console.log('pop state ligL ', e)
  }

  popSet(item: Level) {
    // console.log('TTSO: ', item)
    this.currentLevelDetails = item
    // console.log('hide menu')
    this.visible = false
    this.pop.nativeElement.togglePopover()
    // console.log('Set OK.')
    this.defineChange.emit(item.id)
  }

  checkDefinedRateLevel() {
    // console.log('check definition levels')
    if (this.define) {
      this.rateLevels.forEach(rl => {
        if (this.define === rl.id) {
          this.currentLevelDetails = rl
          // console.log('found definition level')
        }
      })
    }
  }

  /**
   * Init Rate Levels List
   * @param V: VMF
   */
  getRateLevels(V: VendorMinInf) {
    // console.log('Loading rate levels')
    this.preloader = true
    forkJoin([
      this.SRV.getLevelRates(V),
      this.SRV.getVendorProducts(V)
    ]).subscribe((res) => {
      // console.log('got all data:', res)
      // console.log('Levels loaded')
      // console.log(res[0])
      // console.log('')
      // console.log('Product loaded')
      // console.log(res[1])
      // console.log('')
      //
      // console.log('Merge data')

      this.rateLevels = res[0].map(i => {
        i.products.map(p => {
          return p.details = res[1].find(fp => p.productId === fp.id)
        })
        i.minRate = i.products.reduce((prev, curr) => {
          return prev.fit.total < curr.fit.total ? prev : curr
        })
        i.maxRate = i.products.reduce((prev, curr) => {
          return prev.fit.total > curr.fit.total ? prev : curr
        })
        return i
      })
      console.log(this.rateLevels)

      this.checkDefinedRateLevel()
      this.preloader = false
    }, error => {
      this.notify.createTopMessage('Something went wrong on loading Rate Levels', error, 2000)
      this.preloader = false
    })
  }


  /**
   * Subscript on system vendor if not defined
   */
  subscriptOnSystemVendor() {
    // console.log('try to get system vendor')
    this.preloader = true
    this.subVendorSelect = this.VS.selectedVendor.subscribe((data: VendorSearch) => {
        console.log('chosen VS: ', data)
        if (data !== undefined) {
          this.currentVendor = data.vendor
          this.vendorNotDefined = false
          this.getRateLevels(data.vendor)
        } else {
          this.vendorNotDefined = true
        }
        this.preloader = false
      }, error => {
        this.notify.createTopMessage('Something went wrong on loading Rate Levels', error, 2000)
        this.preloader = false
      }
    )
  }


  constructor(
    private SRV: LevelPickerService,
    private notify: NotificatorService,
    private VS: MlVsService,
    private AS: AuthService
  ) {
  }

  ngOnInit() {
    // console.log('LEVEL-PICKER: ', this)
    // Init Auth Service
    // Get Current User Data
    this.subCurrentUser = this.AS.getCurrentUserData().subscribe(usr => {
      this.isUsrAdmin = (usr.accessLevel === 'LEVEL_0') ? true : false
    })

    // Check on Vendor Definition
    if (this.vendorId && this.category) {
      this.vendorNotDefined = false
      this.getRateLevels({
        vendorId: this.vendorId,
        category: this.category
      })
    } else {
      this.subscriptOnSystemVendor()
    }
  }

  ngOnDestroy() {
    if (this.subVendorSelect) {
      this.subVendorSelect.unsubscribe()
    }
    if (this.subCurrentUser) {
      this.subCurrentUser.unsubscribe()
    }
  }

}
